import { useMutation } from "@tanstack/react-query";
import { submitFeedback } from "../services/discuss.service";
import { ISubmitFeedbackRequest } from "../types/discuss.types";

/**
 * Hook for submitting AI response feedback/rating
 */
export const useSubmitFeedback = () => {
  return useMutation({
    mutationFn: (data: ISubmitFeedbackRequest) => submitFeedback(data),
    onSuccess: (data) => {
      console.log("Feedback submitted successfully:", data);
    },
    onError: (error) => {
      console.error("Failed to submit feedback:", error);
    },
  });
};
